import React, { useState, useEffect } from 'react'
import * as Common from '../../../components/common'
import { ApiErrorMessage } from '../../../components/error/alertMessages'


export const blisterListHeading = [
    { text: "check", classNames: ['pl-3 py-1  pr-0'] },
    { text: "PHN", classNames: ['py-1'] },
    { text: "PATIENT NAME", classNames: ['py-1'] },
    { text: "ROUTE", classNames: ['px-3 py-1'] },
    { text: "FACILITY", classNames: ['px-3 py-1'] },
    { text: "NO OF BLISTER", classNames: ['px-3 py-1'] },
    { text: "NOTES", classNames: ['px-3 py-1'] },
    { text: "ACTION", classNames: ['px-3 py-1 flex justify-end'] },
];

export const weekday = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

export const usePDFJobStatus = () => {
    const getSessionJob = () => {
        return JSON.parse(sessionStorage.getItem('job')) || { loading: false, data: null, error: null };
    };

    const [jobStatus, setJobStatus] = useState(getSessionJob());

    useEffect(() => {
        const interval = setInterval(() => {
            const updatedJob = getSessionJob();
            if (JSON.stringify(updatedJob) !== JSON.stringify(jobStatus)) {
                setJobStatus(updatedJob);
            }
        }, 1000); // Polling every 1 second to check for updates

        return () => clearInterval(interval);
    }, [jobStatus]);

    return jobStatus;
};

export const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

export const ViewBlisterPatientActiveMedication = ({ activeMedication, type, activeMedicationDataResponse }) => {

    const calculateSum = (activeMedication, key) => {
        return activeMedication.reduce((sum, item) => {
            const value = item?.data?.scheduledata?.[key] || 0;
            const RXQTY = item?.data?.RXQTY || 0;
            const RXDAYS = item?.data?.RXDAYS || 1;
            const totalSchedule = (item?.data?.scheduledata?.Morning || 0) +
                (item?.data?.scheduledata?.Noon || 0) +
                (item?.data?.scheduledata?.Evening || 0) +
                (item?.data?.scheduledata?.Bedtime || 0);
            const isAlternate = totalSchedule !== RXQTY / RXDAYS;

            // Skip invalid values: 0, below 0, or alternate schedules
            if (value <= 0 || isAlternate) {
                return sum;
            }

            return sum + value;
        }, 0);
    };


    return (
        <>
            {/* <th className="px-6 py-1 text-left text-sm font-semibold">
                <input
                    type="checkbox"
                    value=""
                    checked={allChecked}
                    onChange={handleHeaderCheckboxChange}
                    className="w-5 h-5 text-blue-600 bg-white border-gray-300  rounded focus:ring-transparent focus:ring-2" />
            </th>

            <td className="px-6 py-2">
                <input
                    type="checkbox" value=""
                    checked={checkedItems[index]}
                    onChange={() => handleCheckboxChange(index, value.id)}
                    className="w-5 h-5 text-blue-600 bg-white border-gray-300  rounded focus:ring-transparent focus:ring-2" />
            </td> */}

            {
                activeMedicationDataResponse?.loading && activeMedicationDataResponse.type === type ?

                    <div className='flex my-20 items-center justify-center'>
                        <Common.ProfilePicLoader />
                    </div>

                    :

                    activeMedicationDataResponse?.error?.data?.success === false && activeMedicationDataResponse.type === type ?
                        <div className='flex m-4 items-center text-black font-semibold'>
                            No Record Found.
                        </div>
                        :

                        activeMedication?.length === 0 && activeMedicationDataResponse.type === type ?
                            <div className='flex m-4 items-center text-black font-semibold'>
                                No Record Found.
                            </div>
                            :

                            activeMedicationDataResponse?.error !== null && activeMedicationDataResponse.type === type ?
                                <ApiErrorMessage />
                                :
                                activeMedicationDataResponse.type === type &&
                                <div className="overflow-x-auto">
                                    <table className="w-full">
                                        <thead>
                                            <tr style={{ backgroundColor: '#004F87' }} className="uppercase">
                                                <th className="px-6 py-1 text-left text-sm font-semibold text-white">Rx</th>
                                                <th className="px-6 py-1 text-left text-sm font-semibold text-white">Drug Instructions</th>
                                                <th className="px-6 py-1 text-left text-sm font-semibold text-white whitespace-nowrap">Description</th>
                                                <th className="px-6 py-1 text-left text-sm font-semibold text-white whitespace-nowrap">Doctor</th>
                                                <th className="px-6 py-1 text-left text-sm font-semibold text-white">Qty</th>
                                                <th className="px-6 py-1 text-left text-sm font-semibold text-white whitespace-nowrap">Ref Rem</th>
                                                <th className="px-6 py-1 text-left text-sm font-semibold text-white whitespace-nowrap border-r">Qty Rem</th>
                                                <th className="px-6 py-1 text-center text-sm font-semibold text-white border-r">Bkf</th>
                                                <th className="px-6 py-1 text-center text-sm font-semibold text-white border-r">Lun</th>
                                                <th className="px-6 py-1 text-center text-sm font-semibold text-white border-r">Sup</th>
                                                <th className="px-6 py-1 text-center text-sm font-semibold text-white">Bed</th>
                                            </tr>
                                        </thead>

                                        <tbody className="">
                                            {
                                                (activeMedication)?.map((value, index) => {

                                                    const scheduleData = value?.data?.scheduledata || {};

                                                    const RXQTY = value?.data?.RXQTY;
                                                    const RXDAYS = value?.data?.RXDAYS;

                                                    const morning = scheduleData?.Morning || 0;
                                                    const noon = scheduleData?.Noon || 0;
                                                    const evening = scheduleData?.Evening || 0;
                                                    const bedtime = scheduleData?.Bedtime || 0;

                                                    // Calculate total schedule
                                                    const totalSchedule = morning + noon + evening + bedtime;

                                                    // Determine if it's alternate
                                                    const isAlternate = (totalSchedule !== RXQTY / RXDAYS)

                                                    // Function to handle alternate check
                                                    const checkAlternateSchedule = (value) => {
                                                        if (value < 0) return '<--';
                                                        if (value === 0) return '';
                                                        return isAlternate ? '<--' : value;
                                                    };

                                                    // Get qty
                                                    const getQty = () => {
                                                        if (isAlternate) {
                                                            const getSingleDayDose = (RXQTY / RXDAYS);
                                                            return Math.round(getSingleDayDose * 7); // Weekly calculation
                                                        }
                                                        return totalSchedule * 7; // Weekly calculation based on schedule
                                                    };

                                                    return (<React.Fragment key={index}>
                                                        <tr className={`${index === activeMedication?.length - 1 ? '' : 'border-b border-gray-200'} bg-gray-50 hover:bg-blue-50 `}>

                                                            <td className="px-6 py-2 text-gray-800 ">
                                                                {value?.rxnum}
                                                            </td>

                                                            <td className="px-6 py-2">
                                                                <div className="space-y-1">
                                                                    <p className=" text-gray-800 flex gap-2">

                                                                        <span className="text-black font-semibold">
                                                                            {value?.data?.RXDRUG} -
                                                                        </span>

                                                                        <span className='text-gray-800 font-normal'>
                                                                            {value?.data?.RXDIN}
                                                                        </span>
                                                                    </p>

                                                                    <p className="text-sm text-gray-800">
                                                                        {value?.data?.RXSIG}
                                                                    </p>
                                                                </div>
                                                            </td>

                                                            <td className="px-6 py-2 text-gray-800 text-center">
                                                                {value?.data?.DGCOLOR} {value?.data?.DGMARKINGS}
                                                            </td>

                                                            <td className="px-6 py-2">
                                                                <div className="space-y-1">
                                                                    <p className="text-sm text-gray-800 whitespace-nowrap">
                                                                        {value?.data?.RXDRLAST}, {value?.data?.RXDR1ST}</p>
                                                                </div>
                                                            </td>

                                                            <td className="px-6 py-2 text-gray-800 text-center">
                                                                {getQty()}
                                                            </td>

                                                            <td className="px-6 py-2 text-gray-800 text-center  ">
                                                                {value?.data?.REFLEFT}
                                                            </td>

                                                            <td className="px-6 py-2 text-gray-800 border-r text-center">
                                                                {value?.data?.QTYLEFT}
                                                            </td>

                                                            <td className="px-6 py-2 text-center border-r">
                                                                {checkAlternateSchedule(morning)}
                                                            </td>

                                                            <td className="px-6 py-2 text-center border-r">
                                                                {checkAlternateSchedule(noon)}
                                                            </td>

                                                            <td className="px-6 py-2 text-center border-r">
                                                                {checkAlternateSchedule(evening)}
                                                            </td>

                                                            <td className="px-6 py-2 text-center">
                                                                {checkAlternateSchedule(bedtime)}
                                                            </td>
                                                        </tr>

                                                    </React.Fragment>
                                                    )
                                                })}

                                            {/* {activeMedication?.length > 0 && (
                                                <tr className="bg-50 border-t border-gray-300">
                                                    <td colSpan={7} className="px-6 py-2 text-gray-800"></td>
                                                    <td className="px-6 py-2 text-center border-r">{calculateSum(activeMedication, 'Morning')}</td>
                                                    <td className="px-6 py-2 text-center border-r">{calculateSum(activeMedication, 'Noon')}</td>
                                                    <td className="px-6 py-2 text-center border-r">{calculateSum(activeMedication, 'Evening')}</td>
                                                    <td className="px-6 py-2 text-center">{calculateSum(activeMedication, 'Bedtime')}</td>
                                                </tr>
                                            )} */}

                                        </tbody>
                                    </table>
                                </div>
            }
        </>
    )
}
